import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-arrays-chain-predict',
  slug: 'chain-predict',
  title: 'Mind the hole',
  type: 'predict',
  estSeconds: 60,
  contentVersion: 1,
});
